module.exports = __webpack_public_path__ + "static/img/13.c4b33ae6.jpeg";